import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import Paycheck from "../../../classes/Paycheck";

// Roles permitted to create a paycheck on behalf of an employee. Mirrors
// the role set enforced server-side by verifyPayrollRole() in
// functions/paychecks.js so client-side gating stays consistent.
const canCreatePaycheckForOthers = () => {
  const user = store.state.main.user;
  if (!user) return false;
  return (
    user.isAdmin ||
    user.hasRole?.("accounting") ||
    user.hasRole?.("payroll") ||
    user.hasRole?.("management")
  );
};

export { canCreatePaycheckForOthers };

export default {
  routes: [
    {
      name: "paychecks",
      path: "paychecks",
      meta: {
        auth: () => Paycheck.canBeViewedBy(store.state.main.user),
        icon: "cheque",
        title: i18n.global.tc("Paycheck", 0),
        crumbs: ["accounting", "payroll"],
        color: "primary",
      },
      component: () => import("pages/admin/Paychecks"),
    },
    {
      name: "paychecks-paid",
      path: "paychecks/paid",
      meta: {
        auth: () => Paycheck.canBeViewedBy(store.state.main.user),
        icon: "cheque",
        title: i18n.global.tc("Paycheck", 0),
        crumbs: ["accounting", "payroll"],
        color: "primary",
        hideFromIndex: true,
      },
      component: () => import("pages/admin/Paychecks"),
    },
    {
      name: "paychecks-search",
      path: "paychecks/search/:query?",
      meta: {
        auth: () => Paycheck.canBeViewedBy(store.state.main.user),
        icon: "cheque",
        title: i18n.global.tc("Paycheck", 0),
        crumbs: ["accounting", "payroll"],
        color: "primary",
        hideFromIndex: true,
      },
      component: () => import("pages/admin/Paychecks"),
    },
    {
      name: "admin-create-paycheck-commission",
      path: "paychecks/users/:userID/commission",
      meta: {
        auth: canCreatePaycheckForOthers,
        hideFromIndex: true,
        icon: "commission",
        title: i18n.global.tc("Commission"),
        crumbs: ["accounting", "payroll", "paychecks"],
        color: "primary",
      },
      component: () => import("pages/employee/Commission"),
      props: true,
    },
  ],

  dialogs: [
    {
      name: "admin-create-paycheck-picker",
      path: "/paychecks/create",
      meta: {
        auth: canCreatePaycheckForOthers,
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/PaycheckRecipientPicker"),
    },
    {
      name: "admin-commission-advance",
      path: "/paychecks/advance",
      meta: {
        auth: canCreatePaycheckForOthers,
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CommissionAdvance"),
    },
    {
      name: "admin-create-paycheck-new",
      path: "/paychecks/users/:userID/paychecks/new",
      meta: {
        auth: canCreatePaycheckForOthers,
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/PaycheckEdit"),
    },
    {
      name: "admin-create-paycheck-edit",
      path: "/paychecks/users/:userID/paychecks/:paycheckID/edit",
      meta: {
        auth: canCreatePaycheckForOthers,
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/PaycheckEdit"),
    },
    {
      name: "admin-paycheck-edit",
      path: "/users/:userID/paychecks/:paycheckID/edit",
      meta: {
        auth: () => Paycheck.canBeViewedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/PaycheckEdit"),
    },
    {
      name: "admin-paycheck-view",
      path: "/users/:userID/paychecks/:paycheckID/view",
      meta: {
        auth: () => Paycheck.canBeViewedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/PaycheckView"),
    },
  ],
};
